export const contacts = [
    {
        id: 'телефон',
        icon: 'phone.svg',
        value: '+375445389727',
        action: 'tel:'
    },
    {
        id: 'мобильный',
        icon: 'phone.svg',
        value: '+375445997546',
        action: 'tel:',
    },
    {
        id: 'моб',
        icon: 'phone.svg',
        value: '+375296862900',
        action: 'tel:',
    },
    {
        id: 'email',
        icon: 'email.svg',
        value: 'info@vglobal.by',
        action: 'mailto:',
    },
    {
        id: 'address',
        icon: 'location.svg',
        value: 'г.Минск, ул.Веры Хоружей, 3, офис 305а',
        action: 'https://yandex.by/maps/-/CDTQJTye',
    }
];

export const socials = [
    {
        id: 'instagram',
        icon: 'instagram.png',
        value: 'https://www.instagram.com/voyageglobal_minsk/',
    },
    {
        id: 'telegram',
        icon: 'telegram.png',
        value: 'https://www.t.me/vglobalminsk',
    },
    {
        id: 'viber',
        icon: 'viber.png',
        value: 'viber://chat?number=%2B375445389727'
    }
];
